// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Auth Pages Styles
 */

.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 20px;
}

.auth-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 400px;
}

.auth-card h1 {
  text-align: center;
  font-size: 32px;
  margin-bottom: 10px;
  color: #333;
}

.auth-card h2 {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
  font-size: 20px;
}

.auth-card form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.auth-card input {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
}

.auth-card input:focus {
  outline: none;
  border-color: #2a5298;
  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);
}

.auth-card button {
  background-color: #2a5298;
  color: white;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.auth-card button:hover:not(:disabled) {
  background-color: #1e3c72;
  transform: translateY(-2px);
}

.auth-card button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.auth-card p {
  text-align: center;
  color: #666;
  margin-top: 20px;
}

.auth-card a {
  color: #2a5298;
  text-decoration: none;
  font-weight: bold;
}

.auth-card a:hover {
  text-decoration: underline;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #c3e6cb;
  margin-top: 12px;
}

.resend-verification-row {
  margin-top: 12px;
}

.terms-checkbox-row {
  text-align: center;
  font-size: 13px;
  color: #444;
  line-height: 1.4;
}

.terms-checkbox-row label {
  cursor: pointer;
}

.terms-checkbox-row input[type="checkbox"] {
  accent-color: #2a5298;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 4px;
}

/* Terms & Conditions page */
.terms-card {
  background: white;
  padding: 32px 36px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
}

.terms-card h1 {
  text-align: center;
  font-size: 26px;
  color: #333;
  margin-bottom: 4px;
}

.terms-card .terms-updated {
  text-align: center;
  font-size: 13px;
  color: #888;
  margin-bottom: 24px;
}

.terms-content h2 {
  font-size: 16px;
  color: #1e3c72;
  margin: 20px 0 8px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 4px;
}

.terms-content p,
.terms-content ul {
  font-size: 14px;
  color: #444;
  line-height: 1.6;
  margin: 0 0 10px;
}

.terms-content ul {
  padding-left: 20px;
}

.terms-content li {
  margin-bottom: 4px;
}

.terms-footer {
  margin-top: 24px;
  text-align: center;
}

.terms-back-link {
  color: #2a5298;
  font-weight: bold;
  text-decoration: none;
  font-size: 15px;
}

.terms-back-link:hover {
  text-decoration: underline;
}

.captcha-row {
  margin: 4px 0 12px;
  display: flex;
  justify-content: center;
}

.login-modal-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: transparent;
}

.login-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: transparent;
  z-index: 20;
}

body.login-modal-open {
  background: transparent;
}

.login-modal-card {
  position: relative;
  width: min(100%, 420px);
  margin: 0;
  animation: login-modal-enter 220ms ease-out;
}

.login-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: rgba(42, 82, 152, 0.12);
  color: #1e3c72;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.login-modal-close:hover {
  background: rgba(42, 82, 152, 0.22);
}

@keyframes login-modal-enter {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 480px) {
  .login-modal-card {
    padding: 26px 20px;
  }

  .login-modal-close {
    top: 8px;
    right: 8px;
  }
}

.back-to-login-btn {
  display: inline-block;
  background-color: #2a5298;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
}

.back-to-login-btn:hover {
  background-color: #1e3c72;
  box-shadow: 0 4px 12px rgba(42, 82, 152, 0.3);
}

.guide-login-prompt {
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid #d7e4ff;
  border-radius: 10px;
  background: linear-gradient(135deg, #f6f9ff 0%, #edf3ff 100%);
}

.guide-login-prompt__text {
  margin: 0 0 8px;
  color: #1e3c72;
  font-weight: 600;
  text-align: left;
}

.guide-login-prompt__check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #42507a;
  margin-bottom: 10px;
}

.guide-login-prompt__actions {
  display: flex;
  gap: 8px;
}

.guide-btn {
  border: 1px solid #2a5298;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 10px;
  cursor: pointer;
}

.guide-btn--primary {
  background: #2a5298;
  color: #fff;
}

.guide-btn--primary:hover {
  background: #1e3c72;
}

.guide-btn--ghost {
  background: transparent;
  color: #2a5298;
}

.guide-btn--ghost:hover {
  background: #e8eeff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Auth.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * Auth Pages Styles\n */\n\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  padding: 20px;\n}\n\n.auth-card {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 400px;\n}\n\n.auth-card h1 {\n  text-align: center;\n  font-size: 32px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.auth-card h2 {\n  text-align: center;\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 20px;\n}\n\n.auth-card form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.auth-card input {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\n.auth-card input:focus {\n  outline: none;\n  border-color: #2a5298;\n  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);\n}\n\n.auth-card button {\n  background-color: #2a5298;\n  color: white;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.auth-card button:hover:not(:disabled) {\n  background-color: #1e3c72;\n  transform: translateY(-2px);\n}\n\n.auth-card button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.auth-card p {\n  text-align: center;\n  color: #666;\n  margin-top: 20px;\n}\n\n.auth-card a {\n  color: #2a5298;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.auth-card a:hover {\n  text-decoration: underline;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 12px;\n  border-radius: 4px;\n  border: 1px solid #f5c6cb;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px;\n  border-radius: 4px;\n  border: 1px solid #c3e6cb;\n  margin-top: 12px;\n}\n\n.resend-verification-row {\n  margin-top: 12px;\n}\n\n.terms-checkbox-row {\n  text-align: center;\n  font-size: 13px;\n  color: #444;\n  line-height: 1.4;\n}\n\n.terms-checkbox-row label {\n  cursor: pointer;\n}\n\n.terms-checkbox-row input[type=\"checkbox\"] {\n  accent-color: #2a5298;\n  cursor: pointer;\n  vertical-align: middle;\n  margin-right: 4px;\n}\n\n/* Terms & Conditions page */\n.terms-card {\n  background: white;\n  padding: 32px 36px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.terms-card h1 {\n  text-align: center;\n  font-size: 26px;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.terms-card .terms-updated {\n  text-align: center;\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 24px;\n}\n\n.terms-content h2 {\n  font-size: 16px;\n  color: #1e3c72;\n  margin: 20px 0 8px;\n  border-bottom: 1px solid #e8e8e8;\n  padding-bottom: 4px;\n}\n\n.terms-content p,\n.terms-content ul {\n  font-size: 14px;\n  color: #444;\n  line-height: 1.6;\n  margin: 0 0 10px;\n}\n\n.terms-content ul {\n  padding-left: 20px;\n}\n\n.terms-content li {\n  margin-bottom: 4px;\n}\n\n.terms-footer {\n  margin-top: 24px;\n  text-align: center;\n}\n\n.terms-back-link {\n  color: #2a5298;\n  font-weight: bold;\n  text-decoration: none;\n  font-size: 15px;\n}\n\n.terms-back-link:hover {\n  text-decoration: underline;\n}\n\n.captcha-row {\n  margin: 4px 0 12px;\n  display: flex;\n  justify-content: center;\n}\n\n.login-modal-page {\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background: transparent;\n}\n\n.login-modal-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: transparent;\n  z-index: 20;\n}\n\nbody.login-modal-open {\n  background: transparent;\n}\n\n.login-modal-card {\n  position: relative;\n  width: min(100%, 420px);\n  margin: 0;\n  animation: login-modal-enter 220ms ease-out;\n}\n\n.login-modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background: rgba(42, 82, 152, 0.12);\n  color: #1e3c72;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.login-modal-close:hover {\n  background: rgba(42, 82, 152, 0.22);\n}\n\n@keyframes login-modal-enter {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 480px) {\n  .login-modal-card {\n    padding: 26px 20px;\n  }\n\n  .login-modal-close {\n    top: 8px;\n    right: 8px;\n  }\n}\n\n.back-to-login-btn {\n  display: inline-block;\n  background-color: #2a5298;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.back-to-login-btn:hover {\n  background-color: #1e3c72;\n  box-shadow: 0 4px 12px rgba(42, 82, 152, 0.3);\n}\n\n.guide-login-prompt {\n  margin-bottom: 14px;\n  padding: 12px;\n  border: 1px solid #d7e4ff;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #f6f9ff 0%, #edf3ff 100%);\n}\n\n.guide-login-prompt__text {\n  margin: 0 0 8px;\n  color: #1e3c72;\n  font-weight: 600;\n  text-align: left;\n}\n\n.guide-login-prompt__check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #42507a;\n  margin-bottom: 10px;\n}\n\n.guide-login-prompt__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.guide-btn {\n  border: 1px solid #2a5298;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.guide-btn--primary {\n  background: #2a5298;\n  color: #fff;\n}\n\n.guide-btn--primary:hover {\n  background: #1e3c72;\n}\n\n.guide-btn--ghost {\n  background: transparent;\n  color: #2a5298;\n}\n\n.guide-btn--ghost:hover {\n  background: #e8eeff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
